export default function getEventSource() {
  // eslint-disable-next-line compat/compat
  return typeof window !== 'undefined' && typeof window.EventSource === 'function' ? window.EventSource : undefined;
}


// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@splitsoftware/splitio-react/es/splitio/services/getEventSource/browser.js